/**
 * Created by Administrador on 22/08/2019.
 */
(function () {
    'use strict';

    angular
        .module('completeAir')
        .controller('flightTrackingCtrl', flightTrackingCtrl)
        .controller('flightTrackingDetailCtrl', flightTrackingDetailCtrl)
        .controller('flightTrackingDetailConnectionCtrl', flightTrackingDetailConnectionCtrl)
        .controller('revenueTrackingDetailCtrl', revenueTrackingDetailCtrl)
        .controller('revenueTrackingOversoldCtrl', revenueTrackingOversoldCtrl)
        .controller('revenueActiveDeactivateCtrl', revenueActiveDeactivateCtrl)
        .controller('revenueTrackingDetailConnectionCtrl', revenueTrackingDetailConnectionCtrl);

    flightTrackingCtrl.$inject = ['$stateParams', '$state', 'tabs', 'datePickerService', 'flightTrackingService', 'paginationService', 'Util', 'linkService', 'messageService'];
    flightTrackingDetailCtrl.$inject = ['$stateParams', '$window', 'tabs', 'flightTrackingDetail', 'flightTrackingService'];
    flightTrackingDetailConnectionCtrl.$inject = ['$stateParams', '$window', 'tabs', 'flightTrackingDetail', 'flightTrackingService'];
    revenueTrackingDetailCtrl.$inject = ['$stateParams', '$uibModal', '$window', 'tabs', 'categories', 'flightTrackingDetail', 'flightTrackingService'];
    revenueTrackingOversoldCtrl.$injec = ['$uibModal', '$uibModalInstance', 'segment', 'fareClasses', 'isConnection'];
    revenueActiveDeactivateCtrl.$injec = ['$uibModal', '$uibModalInstance', 'fareClasses', 'flightNumber', 'segments', 'isConnection'];
    revenueTrackingDetailConnectionCtrl.$inject = ['$stateParams', '$uibModal', '$window', 'tabs', 'flightTrackingDetail', 'flightTrackingService'];

    function flightTrackingCtrl($stateParams, $state, tabs, datePickerService, flightTrackingService, paginationService, Util, linkService, messageService) {
        var vm = this;
        vm.tabs = tabs;
        vm.flights = [];
        vm.flightTracking = [];
        vm.pages = paginationService.getPages();
        vm.showPages = false;

        vm.datePickerOpenStatus = {
            flightDate: false
        };
        vm.pickerButtons = datePickerService.pickerButtons();

        vm.datepickerDepartureDate = {
            dateFormat: 'dd/MM/yyyy',
            datepickerOptions: {
                showWeeks: false,
                minDate: null
            },
            closed: function(args) {
            }
        };

        vm.openCalendar = function(date) {
            vm.datePickerOpenStatus[date] = true;
        };

        vm.filterFlightTracking = {
            flightDate : ($stateParams.flightDate !== "") ? new Date(parseInt($stateParams.flightDate)) : new Date(),
            flight: null,
            flightIdConnectionId: ($stateParams.flightIdConnectionId !== "") ? parseInt($stateParams.flightIdConnectionId) : 0,
            isFlight: ($stateParams.isFlight !== "") ? Util.stringToBoolean($stateParams.isFlight) : true,
            status: ($stateParams.status !== "") ? $stateParams.status : 'FLIGHT',
            search: $stateParams.search
        };

        vm.handleType = function(type) {
            vm.flightTracking = [];
            if (type === 2) {
                vm.filterFlightTracking.flightIdConnectionId = 0;
                vm.updateParams(true, null);
            }
            if (vm.filterFlightTracking.isFlight) {
                vm.handleFlightsByFlight()
            } else {
                vm.handleFlightsByConnection()
            }
        }

        vm.handleChangeFlights = function() {
            vm.flightTracking = [];
        }

        vm.handleFlightsByFlight = function() {
            if(vm.filterFlightTracking.flightDate != undefined){
                vm.flights= [];
                flightTrackingService.getFlightsByFlightAll(vm.filterFlightTracking.flightDate.getTime())
                    .then(function (response) {
                        var auxFlights = (response.data._embedded) ? response.data._embedded.flights : [];
                        angular.forEach(auxFlights, function(flight){
                            vm.flights.push({
                                flightNumber: flight.flightNumber,
                                flightId: +linkService.getLinkId(flight._links.self.href),
                                route: flight._embedded.route.initials,
                                flightRoute: flight.flightNumber + ' / ' + flight._embedded.route.initials
                            });
                        });
                        vm.initParams();
                    });
            }
        }

        vm.handleFlightsByConnection = function() {
            if(vm.filterFlightTracking.flightDate != undefined){
                vm.flights= [];
                flightTrackingService.getFlightsByConnectionAll(vm.filterFlightTracking.flightDate.getTime())
                    .then(function (response) {
                        var auxFlights = (response.data._embedded) ? response.data._embedded.connections : [];
                        angular.forEach(auxFlights, function(flight) {
                            var flightNumbers = flightTrackingService.getFlightNumbersByFlightConnections(flight._embedded.departureFlightConnections);
                            vm.flights.push({
                                flightNumber: flightNumbers,
                                flightId: +linkService.getLinkId(flight._links.self.href),
                                route: flight._embedded.route.initials,
                                flightRoute: flightNumbers + ' / ' + flight._embedded.route.initials
                            });
                        });
                        vm.initParams();
                    });
            }
        }

        vm.handleCancelFlightTracking = function() {
            linkService.reloadRoute(linkService.getCurrentRouteName(), {flightDate: new Date().getTime(), flightIdConnectionId: 0, status: 'FLIGHT', isFlight: $stateParams.isFlight, page: 0, size: 10});
        }

        vm.initParams = function() {
            if (vm.filterFlightTracking.flightIdConnectionId !== 0) {
                vm.filterFlightTracking.flight = flightTrackingService.getFlightsByFlightId(vm.flights, vm.filterFlightTracking.flightIdConnectionId);
                if (vm.filterFlightTracking.flight !== null) {
                    vm.handleGenerate(true);
                }
            }
        }

        vm.handleType(1);

        vm.handleGenerate = function (isValid) {
            if (isValid) {
                vm.filterFlightTracking.flightIdConnectionId = vm.filterFlightTracking.flight.flightId;
                vm.showPages = false;
                flightTrackingService.getRevenueAdministration(
                    $stateParams.page, $stateParams.size, vm.filterFlightTracking.flightIdConnectionId, vm.filterFlightTracking.status, vm.filterFlightTracking.isFlight
                ).then(function (response) {
                    vm.flightTracking = (response.data) ? response.data.content : [];
                    vm.pages.totalElements = response.data.totalElements;
                    vm.pages.totalPages = response.data.totalPages;
                    vm.pages.size = response.data.size;
                    vm.pages.number = response.data.number;
                    vm.showPages = true;
                    vm.updateParams(false, response);
                    if (vm.flightTracking.length === 0) {
                        messageService.info('global.noResult', '')
                    }
                });
            }
        }

        vm.updateParams = function (reset, response) {
            var params = angular.copy($state.params);
            params.size = reset ? 10 : response.data.size;
            params.page = reset ? 0 : response.data.number;
            params.flightDate = vm.filterFlightTracking.flightDate.getTime();
            params.flightIdConnectionId = reset ? 0 : vm.filterFlightTracking.flightIdConnectionId;
            params.isFlight = vm.filterFlightTracking.isFlight;

            $state.transitionTo($state.current, params, {
                notify: false,
                reload: false,
            });
        }


    }

    function flightTrackingDetailCtrl($stateParams, $window, tabs, flightTrackingDetail, flightTrackingService) {
        var vm = this;
        vm.data = flightTrackingDetail.data;
        vm.date = $stateParams.date;
        vm.route = $stateParams.route;
        vm.flightNumber = $stateParams.flightNumber;
        vm.logData = JSON.parse(vm.data.log);
        vm.logData.source = JSON.parse(vm.logData.source);
        vm.departureFlights = vm.logData.departureDTOS;
        vm.segmentFlights = vm.logData.segmentDTOS;

        vm.goBack = function() {
            $window.history.back();
        };

    }

    function flightTrackingDetailConnectionCtrl($stateParams, $window, tabs, flightTrackingDetail, flightTrackingService) {
        var vm = this;
        vm.data = flightTrackingDetail.data;
        vm.date = $stateParams.date;
        vm.route = $stateParams.route;
        vm.flightNumber = $stateParams.flightNumber;
        vm.logData = JSON.parse(vm.data.log);
        vm.logData.source = JSON.parse(vm.logData.source);
        vm.segments = vm.logData.segments;
        vm.goBack = function() {
            $window.history.back();
        };
    }

    function revenueTrackingDetailCtrl($stateParams, $uibModal, $window, tabs, categories, flightTrackingDetail, flightTrackingService) {
        var vm = this;
        vm.$uibModal = $uibModal;
        vm.data = flightTrackingDetail.data;
        vm.date = $stateParams.date;
        vm.route = $stateParams.route;
        vm.flightNumber = $stateParams.flightNumber;
        vm.logData = JSON.parse(vm.data.log);
        vm.segments = vm.logData.segments;
        vm.fareClasses = vm.logData.fareClasses;
        vm.categories = categories;

        vm.handleOverLoad = function(segment) {
            var modalInstance = vm.$uibModal.open({
                templateUrl: 'app/admin/report/auditRegistration/flightTracking/oversold.html',
                controller: 'revenueTrackingOversoldCtrl',
                controllerAs: 'vm',
                size: 'lg',
                resolve: {
                    'segment': [function () {
                        return segment
                    }],
                    'fareClasses': [function () {
                        return vm.logData.fareClasses
                    }],
                    'isConnection': [function () {
                        return false
                    }]
                }
            });
            modalInstance.result.then(function (res) {
            }, function () {
            });
        }

        vm.handleActiveDeactivate = function(segment) {
            var modalInstance = vm.$uibModal.open({
                templateUrl: 'app/admin/report/auditRegistration/flightTracking/activeDeactivateClasses.html',
                controller: 'revenueActiveDeactivateCtrl',
                controllerAs: 'vm',
                size: 'lg',
                resolve: {
                    'fareClasses': [function () {
                        return vm.logData.fareClasses
                    }],
                    'flightNumber': [function () {
                        return vm.logData.flightNumber
                    }],
                    'segments': [function () {
                        return vm.logData.segments;
                    }],
                    'isConnection': [function () {
                        return false
                    }]
                }
            });
            modalInstance.result.then(function (res) {
            }, function () {
            });
        }

        vm.goBack = function() {
            $window.history.back();
        };

    }

    function revenueTrackingOversoldCtrl($uibModal, $uibModalInstance, segment, fareClasses, isConnection) {
        var vm = this;
        vm.segment = segment;
        vm.fareClasses = fareClasses;

        vm.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        }
    }

    function revenueActiveDeactivateCtrl($uibModal, $uibModalInstance, fareClasses, flightNumber, segments, isConnection) {
        var vm = this;
        vm.fareClasses = fareClasses;
        vm.flightNumber = flightNumber;
        vm.segments = segments;
        vm.isConnection = isConnection;

        vm.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        }
    }

    function revenueTrackingDetailConnectionCtrl($stateParams, $uibModal, $window, tabs, flightTrackingDetail, flightTrackingService) {
        var vm = this;
        vm.$uibModal = $uibModal;
        vm.data = flightTrackingDetail.data;
        vm.date = $stateParams.date;
        vm.route = $stateParams.route;
        vm.flightNumber = $stateParams.flightNumber;
        vm.logData = JSON.parse(vm.data.log);

        vm.handleOverLoad = function(segment) {
            var modalInstance = vm.$uibModal.open({
                templateUrl: 'app/admin/report/auditRegistration/flightTracking/oversold.html',
                controller: 'revenueTrackingOversoldCtrl',
                controllerAs: 'vm',
                size: 'lg',
                resolve: {
                    'segment': [function () {
                        return segment
                    }],
                    'fareClasses': [function () {
                        return vm.logData.fareClasses
                    }],
                    'isConnection': [function () {
                        return true
                    }]
                }
            });
            modalInstance.result.then(function (res) {
            }, function () {
            });
        }

        vm.handleActiveDeactivate = function(segment) {
            var modalInstance = vm.$uibModal.open({
                templateUrl: 'app/admin/report/auditRegistration/flightTracking/activeDeactivateClasses.html',
                controller: 'revenueActiveDeactivateCtrl',
                controllerAs: 'vm',
                size: 'lg',
                resolve: {
                    'fareClasses': [function () {
                        return vm.logData.fareClasses
                    }],
                    'flightNumber': [function () {
                        return vm.logData.flightNumber
                    }],
                    'segments': [function () {
                        return vm.logData.segments;
                    }],
                    'isConnection': [function () {
                        return true
                    }]
                }
            });
            modalInstance.result.then(function (res) {
            }, function () {
            });
        }

        vm.goBack = function() {
            $window.history.back();
        };
    }

})();
